import { useSelector as useReduxSelector } from '@oceanjs/core';
/**
 * Wrapper for useSelector to apply an prefix to the state
 * @param prefix global state prefix (usually lib or app)
 * @param selector the selector function
 * @param equalityFn the function that will be used to determine equality
 * @returns the selected state
 */
export function usePrefixedSelector(prefix, selector, equalityFn) {
    function selectorFunction(state) {
        return selector(state[prefix]);
    }
    return useReduxSelector(selectorFunction, equalityFn);
}
//# sourceMappingURL=usePrefixedSelector.js.map